import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 1;
  min-height: 180px;
  overflow: hidden;
  border-radius: ${size.radius['radius-lg']};
  background: ${semantic.bg.surfaceSubtle};
  isolation: isolate;
`;

export const Image = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    transparent 35%,
    ${primitives.color.black['color-black-alpha-600']} 100%
  );
  pointer-events: none;
`;

export const Content = styled.div`
  position: absolute;
  inset: auto 0 0 0;
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
  padding: ${space['space-600']};
  color: ${semantic.text.inverse};
`;

export const Title = styled.h3`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.medium};
  margin: 0;
  line-height: ${primitives.typography.lineHeight.tight};
  color: inherit;
`;

export const Subtitle = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  margin: 0;
  color: inherit;
  opacity: 0.95;
`;

export const Cta = styled.div`
  margin-top: ${space['space-200']};
  align-self: flex-start;
`;

export const Placeholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.tertiary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
`;
